"use strict";
import { t } from "uniswap/src/i18n";
import { v4 as uuid } from "uuid";
export class UserRejectedRequestError extends Error {
  constructor(message) {
    super(message);
    this.name = "UserRejectedRequestError";
  }
}
export function toReadableError(errorText, error) {
  if (typeof error === "object" && error !== null) {
    const e = error;
    return new Error(`${errorText} \u{1F47A} ${e.message ?? e.reason ?? "unknown"}`);
  }
  return new Error(`${errorText} \u{1F47A} ${error}`);
}
export class WrongChainError extends Error {
  constructor() {
    super(t("wallet.wrongNet"));
  }
}
export class UniswapXv2HardQuoteError extends Error {
  constructor() {
    super(t("uniswapx.v2QuoteFailed"));
    this.name = "UniswapXv2HardQuoteError";
  }
}
export class SignatureExpiredError extends Error {
  _id;
  constructor() {
    super(t("common.signatureExpired"));
    this.name = "SignatureExpiredError";
    this._id = `SignatureExpiredError-${uuid()}`;
  }
  get id() {
    return this._id;
  }
}
